<template>
    <header>
        <div class="row wrapper">
            <div class="col-md-6 col-9">
                <div class="row">
                    <div class="logo col-md-5 col-4">
                        <router-link class="d-none d-sm-none d-md-none d-lg-block" :to="to"><img src="../assets/img/logo-negative.svg" alt="" /></router-link>
                        <router-link class="d-sm-block d-md-none" to="/patients"><img src="../assets/img/logo-small.svg" alt="" /></router-link>
                    </div>
                    <div class="icons col-md-7 col-8">
                        <router-link v-if="globals.auth != 9 && globals.auth != 10" to="/profile/tasks"><img src="../assets/img/icon-tasks.svg" alt="" /><span class="badge" v-if="taskCount > 0">{{taskCount}}</span></router-link>
                        <router-link to="/profile/chat"><img src="../assets/img/icon-chat.svg" alt="" /><span class="badge" v-if="messageCount > 0">{{messageCount}}</span></router-link>
                        <router-link to="/profile/notifications"><img src="../assets/img/icon-notification.svg" alt="" /><span class="badge" v-if="notificationCount > 0">{{notificationCount}}</span></router-link>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-3 profile">
                <div class="row">
                    <div class="d-none d-sm-none d-md-block profilename col-8">
                        <router-link to="/profile/user">{{globals.username}}</router-link>
                        <router-link to="/profile/user">{{globals.companyName}}</router-link>
                    </div>
                    <div class="menuicon col-2">
                        <a href="#" v-on:click.prevent="toggleMenu"><img src="../assets/img/icon-menu.svg" alt="" /></a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import
{
    mapGetters
}
from 'vuex'

export default
{
    name: 'Header',
    data()
    {
        return {
            msg: 'Welcome to Your Vue.js App'
        }
    },
    methods:
    {
        toggleMenu: function()
        {
            this.$store.commit('toggleMenu')
        }
    },
    computed:
    {
        ...mapGetters([
            'messageCount',
            'taskCount',
            'notificationCount',
            'globals'
        ]),
        to()
        {
            const me = this;
            if(me.globals.acl.Patients.insertAction == 0 && me.globals.acl.DentalSolutions.instantiate == 1)
            {
                return '/dentalsolutions';
            }
            else
            {
                return '/patients';
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue